// extracted by mini-css-extract-plugin
module.exports = {"anchorGroup":"AnchorAudioButton_anchorGroup__G0CpJ","audio":"AnchorAudioButton_audio__2c2bD","anchor":"AnchorAudioButton_anchor__2l1NU"};